import get from 'lodash/get';
import { getWorkspacePermissionApi } from '../../../../components/apis/workspace_api/view';
import { getTimezoneApi } from 'library-@/apis/core_basic_api/patent';
import {
    createCommentsFromSrpApi,
    addCommentApi,
    deleteCommentsFromSpaceApi,
    deleteCommentsFromSrpApi,
    getSpaceCommentsFromSrpApi,
    getSpaceCommentsFromWorkspaceApi,
    updateCommentApi,
    editCommentsFromSrpApi,
} from 'library-@/apis/workspace_api/comments';

const done = resp => get(resp, 'data.data', {});

export default class CommentService {

    visible_scope = 'ALL';

    data_type = 'PATENT';
 
    // srp区别与ws进入的spaceId
    filter_space_id = '';

    constructor(patentId, spaceId, folderId) {
        this.patentId = patentId;
        this.spaceId = spaceId || undefined;
        this.folderId = folderId || undefined;
        this.timeZone = {};
        this.userId = get(window, 'zPREFACE.globalConfig.userInfo.encryptId');
    }

    setVisibleScope(options) { 
        const { key = 'ALL', extraKey } = options;
        this.visible_scope = key;
        this.filter_space_id = extraKey;
    }

    async getCommentTimeZone() {
        const timezone = await getTimezoneApi().then(done);
        return timezone || {};
    }

    async getCommentList() {
        let commentList;
        if (this.folderId) {
            const resp = await getSpaceCommentsFromWorkspaceApi({ folder_id: this.folderId, data_id: this.patentId, visible_scope: this.visible_scope, filter_space_id: this.filter_space_id });
            commentList = resp.comment_info;
        } else {
            const resp = await getSpaceCommentsFromSrpApi({ data_id: this.patentId, visible_scope: this.visible_scope, filter_space_id: this.filter_space_id  });
            commentList = resp.comment_info;
        }
        return commentList || [];
    }

    createComment(commentText, commentTo, commentToId, wordingId, visibleScope) {
        const params = {
            data_id: this.patentId,
            comment_by: this.userId,
            comment_to: commentTo,
            comment_to_id: commentToId,
            comment_text: commentText,
            wording_id: wordingId,
            data_type: this.data_type,
            visible_scope: visibleScope,
        };
        if (this.folderId) {
            params.folder_id = this.folderId;
            return addCommentApi(params);
        }
        return createCommentsFromSrpApi(params);
    }

    editComment(data) {
        const params = {
            data_id: this.patentId,
            comment_text: data.commentText,
            comment_id: data.commentId,
            visible_scope: data.visibleScope,
            data_type: this.data_type,
        };
        if (this.folderId) {
            params.folder_id = this.folderId;
            return updateCommentApi(params);
        }
        return editCommentsFromSrpApi(params);
    }

    deleteComment(commentId) {
        const params = {
            data_id: this.patentId,
            comment_id: commentId,
        };
        if (this.folderId) {
            params.folder_id = this.folderId;
            return deleteCommentsFromSpaceApi(params);
        }
        return deleteCommentsFromSrpApi(params);
    }

    getCommentsPermission(spaceId, folderId) {
        return getWorkspacePermissionApi({ spaceId, folderId });
    }

    async editThenGetComment(params) {
        await this.editComment(params);
        return await this.getCommentList();
    }

    async createThenGetCommentList(commentText, commentTo, commentToId, wordingId, visibleScope) {
        const comment = await this.createComment(commentText, commentTo, commentToId, wordingId, visibleScope);
        const commentList = await this.getCommentList();
        return { comment_id: comment.comment_id, commentList, comment };
    }

    async deleteThenGetCommentList(commentId) {
        const deletedComment = await this.deleteComment(commentId);
        const commentList = await this.getCommentList();
        return { commentList, deletedComment };
    }
}
